import { combineReducers } from 'redux';
import adminPromoCodesReducer from './adminPromoCodesReducer';
import adminPromoCodeReducer from './adminPromoCodeReducer';

export default combineReducers({
  entitiesState: adminPromoCodesReducer,
  entityState: adminPromoCodeReducer,
});
